import React from "react";
import { Col, Row } from "react-bootstrap";

const AboutChild_Awards = (props) => {
  return (
    <>
      <h2 className="m-0 pb-3">My Awards</h2>
      <hr />
      <Row className="py-3">
        <Col md={5} xs={5}>
          <h6 className="title-primary">2011</h6>
        </Col>
        <Col md={7} xs={7}>
          <h5 className="title-primary">Good Academic Grades Award</h5>
          <span>St. Xavier's College</span>
        </Col>
      </Row>
      <hr />
    </>
  );
};

export default AboutChild_Awards;
